var global, factory;

global = this, factory = function(exports, mobx) {
  function _defineProperty(obj, key, value) {
    return key in obj ? Object.defineProperty(obj, key, {
      value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : obj[key] = value, obj;
  }
  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter((function(sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      }))), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  exports.RouterStore = function RouterStore() {
    var _this = this;
    !function(instance, Constructor) {
      if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }(this, RouterStore), this.history = void 0, this.location = {
      pathname: "",
      search: "",
      state: "",
      hash: ""
    }, this.updateLocation = mobx.action((function(newState) {
      _this.location = newState;
    })), this.push = void 0, this.replace = void 0, this.go = void 0, this.goBack = void 0, 
    this.goForward = void 0, mobx.makeObservable(this, {
      location: mobx.observable
    });
  }, exports.syncHistoryWithStore = function(history, store) {
    // Initialise store
    store.history = history, store.push = history.push.bind(history), store.replace = history.replace.bind(history), 
    store.go = history.go.bind(history), store.goBack = history.goBack.bind(history), 
    store.goForward = history.goForward.bind(history);
    // Handle update from history object
    var handleLocationChange = function(location) {
      store.updateLocation(location);
    }, unsubscribeFromHistory = history.listen(handleLocationChange);
    return handleLocationChange(history.location), store.history.subscribe = function(listener) {
      // Listen for changes to location state in store
      var unsubscribeFromStore = mobx.observe(store, "location", (function(_ref) {
        var rawLocation = function(target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = null != arguments[i] ? arguments[i] : {};
            i % 2 ? ownKeys(Object(source), !0).forEach((function(key) {
              _defineProperty(target, key, source[key]);
            })) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach((function(key) {
              Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
            }));
          }
          return target;
        }({}, _ref.newValue);
        listener(rawLocation, history.action);
      }));
      return listener(store.location, history.action), unsubscribeFromStore;
    }, store.history.unsubscribe = unsubscribeFromHistory, store.history;
  }, Object.defineProperty(exports, "__esModule", {
    value: !0
  });
}, "object" == typeof exports && "undefined" != typeof module ? factory(exports, require("mobx")) : "function" == typeof define && define.amd ? define([ "exports", "mobx" ], factory) : factory((global = "undefined" != typeof globalThis ? globalThis : global || self).MobxReactRouter = {}, global.mobx);
//# sourceMappingURL=mobx-react-router.js.map
